import { z } from "zod";

import { REGISTER_LIMITS, REGISTER_PASSWORD_REGEX } from "../constants/register.constants";

export interface ResetPasswordSchemaTranslator {
  (key: "required" | "min" | "number" | "symbol" | "match"): string;
}

export const createResetPasswordSchema = (t: ResetPasswordSchemaTranslator) =>
  z
    .object({
      newPassword: z
        .string()
        .min(1, t("required"))
        .min(REGISTER_LIMITS.PASSWORD_MIN, t("min"))
        .regex(REGISTER_PASSWORD_REGEX.HAS_NUMBER, t("number"))
        .regex(REGISTER_PASSWORD_REGEX.HAS_SYMBOL, t("symbol")),
      confirmPassword: z.string().min(1, t("required")),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
      path: ["confirmPassword"],
      message: t("match"),
    });

export type ResetPasswordFormValues = z.infer<ReturnType<typeof createResetPasswordSchema>>;
